import { Spinner } from "@snapchat/snap-design-system";

import { SpinnerContainer } from "../../common/components";

export const DashboardSpinner = () => (
    <SpinnerContainer justifyContent="center" data-testid="dashboard-spinner">
        <Spinner />
    </SpinnerContainer>
);
